import { render, staticRenderFns } from "./StoresBody.vue?vue&type=template&id=1f0b7c34&scoped=true&"
import script from "./StoresBody.vue?vue&type=script&lang=ts&"
export * from "./StoresBody.vue?vue&type=script&lang=ts&"
import style0 from "./StoresBody.vue?vue&type=style&index=0&id=1f0b7c34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b7c34",
  null
  
)

export default component.exports